export default {
  header: "How to reach me!",
  view: "contact"
};
